import Vue from 'vue'
import App from './App.vue'
import store from "./../store/index.js";
import  '../assets/style/core/variables/fonts.scss';

Vue.config.productionTip = false
import './partners.scss';
new Vue({
  el: '#widget-partners',
  store,
  render(createElement) {
    return createElement(App, {
      props: {
        options: document.getElementById('widget-partners')?.getAttribute('options')
      }
    });
  }
})
